<div class="schedule-time">
    <span *ngIf="label"class="label">{{ label }}</span>
    <time [dateTime]="time.startTime">{{ time.startTimeOutput }}</time> 
    <span *ngIf="time.startTime !== time.endTime">{{ separator }}</span>
    <time *ngIf="time.startTime !== time.endTime" [dateTime]="time.endTime">{{ time.endTimeOutput }}</time>
</div>
